import React from 'react'
import { Box } from '@mui/material'

// Mirrors lucide-react's panel-left icon family (rect + divider = PanelLeft; the arrow =
// PanelLeftOpen/PanelLeftClose), composed by hand rather than swapping between those three
// packaged components. Hand-composed because: MUI's SvgIcon forces `fill: currentColor` via
// its own class, overriding Lucide's `fill: none` and painting the rect solid; and the arrow
// needs to be its own element so hover can fade it in via CSS alone, no JS state needed.
// Keep strokeWidth/line caps in sync with lucide-react if that library's style ever changes.
export const SidebarToggleIcon: React.FC<{ open: boolean }> = ({ open }) => (
    <Box
        component="svg"
        width={20}
        height={20}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        sx={{
            '& .sidebar-toggle-arrow': {
                opacity: 0,
                transition: 'opacity 150ms ease',
            },
            '.MuiIconButton-root:hover &, .MuiIconButton-root:focus-visible &': {
                '& .sidebar-toggle-arrow': {
                    opacity: 1,
                },
            },
        }}
    >
        <rect width="18" height="18" x="3" y="3" rx="2" />
        <path d="M9 3v18" />
        <path className="sidebar-toggle-arrow" d={open ? 'm16 15-3-3 3-3' : 'm14 9 3 3-3 3'} />
    </Box>
)
